import { lazy } from 'react';

// project imports
import MinimalLayout from 'layout/MinimalLayout';
import Loadable from 'ui-component/Loadable';

const FakeAccountDelete = Loadable(lazy(() => import('../views/open-pages/fake-account-delete/index')));

const OpenRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/accountDelete',
            element: <FakeAccountDelete />
        }
    ]
};

export default OpenRoutes;
